import workspaceQuery from 'graphql/queries/system/SystemSmtpConfigWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/system/SystemSmtpConfigListQuery.graphql';
import instanceQuery from 'graphql/queries/system/SystemSmtpConfigQuery.graphql';
import defaultQuery from 'graphql/queries/system/SystemSmtpConfigDefault.graphql';
import mutationQuery from 'graphql/mutations/system/SystemSmtpConfigMutation.graphql';
import fragment from 'graphql/fragments/system/SystemSmtpConfigFragment.graphql';
import { ALLOW_ADD, ALLOW_DELETE, ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';
import { formActions } from '../../../actions/system/SmtpConfigAction';

const SystemSmtpConfig: EntityType = {
  type: 'SmtpConfig',
  title: 'SMTP Servers',
  formTitle: 'SMTP Server',
  formUrl: '/System/SmtpConfig/Details/',
  workspaceUrl: '/System/SmtpConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'SYSTEM_SMTP',
  actions: [...formActions],
  operations: ALLOW_ADD | ALLOW_EDIT | ALLOW_VIEW | ALLOW_DELETE,
};

export default SystemSmtpConfig;
